<script>
  import {
    customersMethods,
  } from '@state/helpers'
  import {
    PlusIcon,
    XIcon,
    Edit3Icon,
    MailIcon,
    PhoneIcon,
    UserIcon,
    UserPlusIcon,
    UsersIcon,
  } from 'vue-feather-icons'
  import Multiselect from 'vue-multiselect'
  import { ensureOnlyOnePrimary } from '@utils/select-one-primary-object'
  import _isEmpty from 'lodash/isEmpty'
  import {
    resolvePhoneNumber,
    resolveTelephoneURI,
  } from '@utils/phoneNumber'
  export default {
    components: {
      Multiselect,
      UserPlusIcon,
      PlusIcon,
      XIcon,
      Edit3Icon,
      MailIcon,
      PhoneIcon,
      UserIcon,
      UsersIcon,
    },
    props: {
      formError: {
        type: Object,
        required: true
      },
      customers: {
        type: Array,
        required: true
      },
      selectLabel: {
        type: String,
        default: "Select Customer"
      },
      errorKey: {
        type: String,
        default: "customers"
      },
    },
    data() {
      return {
        innited: {
          customer : false,
          customerContact : false,
        }
      }
    },
    methods: {
      ...customersMethods,
      _isEmpty,
      ensureOnlyOnePrimary,
      resolvePhoneNumber,
      resolveTelephoneURI,
      tryToSelectOnePrimary(index) {
        this.$nextTick(() => {
          this.ensureOnePrimary(this.customers, index)
        });
      },
      addCustomer() {
        this.customers.push(
          {
            data: {},
            is_primary: false,
            is_edit: true,
            is_display: false,
          }
        );
      },
      removeCustomer(index) {
        if (this.customers[index].is_primary && this.customers.length > 1){
          this.ensureOnlyOnePrimary(this.customers, index)
        }
        this.customers.splice(index, 1)
      },
      toggleDisplayMoreCustomer(index){
        const customer = this.customers[index]
        this.$set(customer, 'is_display', !customer.is_display)
      },
      toggleEditCustomer(index, toggle = true) {
        const customer = this.customers[index]
        customer.is_edit = toggle
        this.$set(customer, 'is_display', false)
        this.$set(this.customers, index, customer)
      },
      canUpdate(index){
        const customer = this.customers[index]
        if (this.isValid(customer)){
          return true
        }
        return false
      },
      canRemove(index){
        const usableCustomers = this.customers.filter(el => this.isValid(el))
        if (usableCustomers && usableCustomers.length > 1){
          return true
        }
        if (this.customers.length < 2){
          return false
        }
        return !this.canUpdate(index)
      },
      isValid(customer){
        if(customer && customer.data.name && customer.data.contact){
          return true
        }
        return false
      },
      tryToGetData(params){
        params.keyword = params.search
        return this.searchCustomers({ statuses: ['active'], ...params })
      },
      resolveOptions(customer){
        if (customer && customer.data && customer.data.name && customer.data.contacts){
          return customer.data.contacts
        }
        return [{ id: 0, full_name: '' }]
      },
      shouldDisable(customer){
        if (customer && customer.data && customer.data.name){
          return false
        }
        return true
      },
      updateContact(index){
        if (index === 0){
          this.innited.customerContact = true
        }
        const contact = this.customers[index].data.contact
        if(contact && this._isEmpty(contact.primary_phone) && contact.phones && contact.phones.length > 0){
          const primary = contact.phones.find(el => el.is_primary)
          if (primary){
            this.$set(contact, 'primary_phone', primary)
          }
        }
        if(contact && this._isEmpty(contact.primary_email) && contact.emails && contact.emails.length > 0){
          const primary = contact.emails.find(el => el.is_primary)
          if (primary){
            this.$set(contact, 'primary_email', primary)
          }
        }
      },
      resolveEntity(contact, key){
        if (contact && contact[`primary_${key}`] && contact[`primary_${key}`][key]){
          return contact[`primary_${key}`][key]
        }
        if (contact && contact[`${key}s`] && contact[`${key}s`].length > 0){
          return contact[`${key}s`][0]
        }
      }
    }
  };
</script>
<template>
  <div class="form-block">
    <template v-if="customers && customers.length > 0">
      <div v-for="(customer, index) in customers" :key="index" :class="{ 'tw-pt-3': index !== 0, 'tw-pt-2': index === 0 }">
        <div
          v-if="!customer.is_edit"
          class="edit-form-item tw-flex-col md:tw-flex"
          :class="{
            'border-col-error': !isValid(customer),
            'tw-pr-[5.5rem]': !canRemove(index),
            'tw-pr-[8.5rem]': canRemove(index),
          }">
          <div
            class="item-info !tw-h-11"
            :class="{ 'tw-border-b': customer.is_display }">
            <div class="tw-w-full tw-px-4 left-ct tw-flex tw-items-center tw-overflow-hidden">
              <div class="tw-flex fl-left-right tw-w-full tw-justify-start tw-overflow-hidden">
                <div class="tw-min-w-[3.5rem] tw-pr-2 tw-truncate">
                  <section v-if="customer.data && customer.data.name" class="tw-w-full text-bold tw-inline-flex tw-truncate">
                    <span v-if="customer.is_primary" class="block-status border rounded-pill pl-1 mr-2 tw-flex">
                      <span class="status-icon status-completed" style="margin-right: 0.25rem;"/>
                    </span>
                    <span class="mg-r-10 tw-truncate">{{customer.data.name}}</span>
                  </section>
                </div>
                <span class="col-blue font-weight-bold pr-2 text-lg">(</span>
                <div
                  v-if="customer.data.contact && customer.data.contact.full_name"
                  class="tw-px-1.5 fl-inline-center tw-hidden xs:tw-flex tw-whitespace-nowrap">
                  <UserIcon size="1.2x" class="mg-r-5 stroke-blue no-hover"/>{{customer.data.contact.full_name}}
                </div>
                <div
                  v-if="customer.data.contact && customer.data.contact.primary_phone && customer.data.contact.primary_phone.phone"
                  class="tw-px-1.5 fl-inline-center tw-hidden xs:tw-flex tw-whitespace-nowrap">
                  <PhoneIcon size="1.25x" class="tw-min-w-5 mg-r-5 stroke-blue no-hover"/>
                  <a :href="`${resolveTelephoneURI(customer.data.contact.primary_phone.phone)}`">{{resolvePhoneNumber(customer.data.contact.primary_phone.phone)}}</a>
                </div>
                <div
                  v-if="customer.data.contact && customer.data.contact.primary_email && customer.data.contact.primary_email.email"
                  class="tw-min-w-24 tw-px-1.5 fl-inline-center tw-hidden xs:tw-flex tw-whitespace-nowrap tw-truncate">
                  <MailIcon size="1.25x" class="tw-min-w-5 mg-r-5 stroke-blue no-hover"/>
                  <a class="tw-truncate" :href="`mailto:${customer.data.contact.primary_email.email}`">{{customer.data.contact.primary_email.email}}</a>
                </div>
                <span class="col-blue font-weight-bold pl-2 text-lg">)</span>
              </div>
            </div>
            <div
              class="action-group mg-l-auto !tw-h-11"
              :class="{ 'tw-border-b tw-border-gray-300': customer.is_display }">
              <button class="tw-group btn btn-icon button-action button-action-active tw-block" @click="toggleDisplayMoreCustomer(index)">
                <BaseChevronRotate
                  transition-class="rotate-360-180"
                  double
                  :toggle="!!(customer.is_display)"
                  :duration="500"
                  class="tw-text-black group-hover:tw-text-white"
                />
              </button>
              <button
                class="btn btn-icon button-action button-action-positive"
                :class="{
                  '!tw-rounded-br-none': !canRemove(index) && customer.is_display,
                }"
                @click="toggleEditCustomer(index)">
                <Edit3Icon size="1x" class="custom-class"></Edit3Icon>
              </button>
              <button
                v-if="canRemove(index)"
                class="btn btn-icon button-action button-action-negative"
                :class="{
                  '!tw-rounded-br-none': customer.is_display,
                }"
                @click="removeCustomer(index)">
                <XIcon size="1x" class="custom-class"></XIcon>
              </button>
            </div>
          </div>
          <FabricCollapse
            :id="`user-detail-collapse-${index}`"
            v-model="customer.is_display"
            hide-header
            :duration="500"
            class="tw-w-full show tw-justify-start">
            <div
              class="tw-px-5 tw-flex tw-flex-col tw-text-base tw-py-1"
              :class="{
                'tw-mr-[-22px]': !canRemove(index),
                'tw--mr-36': canRemove(index),
              }">
              <section v-if="customer.is_primary" class="tw-flex tw-items-center">
                <UserPlusIcon size="1.2x" class="mg-r-5 tw-text-green-500 tw-stroke-2.5 no-hover tw-inline-flex"/>
                <span>Primary Contact</span>
              </section>
              <section v-if="customer.data.name" class="tw-overflow-ellipsis tw-truncate">
                <UsersIcon size="1.2x" class="mg-r-5 tw-text-black tw-stroke-2.5 no-hover tw-inline-flex"/>
                <span>{{customer.data.name}}</span>
              </section>
              <section v-if="customer.data.contact && customer.data.contact.full_name" class="tw-overflow-ellipsis tw-truncate">
                <UserIcon size="1.2x" class="mg-r-5 stroke-blue no-hover tw-inline-flex"/>
                <span>{{customer.data.contact.full_name}}</span>
              </section>
              <span v-if="customer.data.contact && customer.data.contact.primary_phone && customer.data.contact.primary_phone.phone" class="tw-overflow-ellipsis tw-truncate">
                <PhoneIcon size="1.2x" class="mg-r-5 stroke-blue no-hover tw-inline-flex"/>
                <a :href="`${resolveTelephoneURI(customer.data.contact.primary_phone.phone)}`">{{resolvePhoneNumber(customer.data.contact.primary_phone.phone)}}</a>
              </span>
              <span v-if="customer.data.contact && customer.data.contact.primary_email && customer.data.contact.primary_email.email" class="tw-overflow-ellipsis tw-truncate">
                <MailIcon size="1.2x" class="mg-r-5 stroke-blue no-hover tw-inline-flex"/>
                <a :href="`mailto:${customer.data.contact.primary_email.email}`">{{customer.data.contact.primary_email.email}}</a>
              </span>
            </div>
          </FabricCollapse>
        </div>
        <div
          v-else
          class="border border-radius-20 bg-gray pd-20">
          <div class="form-block">
            <div :class="['form-group', 'tw-mb-2', { 'is-invalid': formError[`${errorKey}.${index}.customer_id`] || (index === 0 && innited.customer && !customer) }]">
              <label>{{selectLabel}}</label>
              <FabricSelect
                v-model="customers[index].data"
                :custom-label="customer => customer.name ? customer.name : ''"
                :get-data="params => tryToGetData(params)"
                :timeout-duration="1"
                @change="index === 0 ? innited.customer = true : ''"
              />
              <p v-if="formError && formError[`${errorKey}.${index}.customer_id`]" class="text-danger">{{ formError[`${errorKey}.${index}.customer_id`] }}</p>
            </div>
            <div :class="['form-group', 'tw-pt-2', { 'is-invalid': formError[`${errorKey}.${index}.contact`] || (index === 0 && innited.customerContact  && !( customer && customer.data && customer.data.contact)) }]">
              <label>Customer's Contact</label>
              <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-start tw-justify-between">
                <div class="tw-w-full md:tw-w-9/12" :class="{ 'is-invalid': formError[`${errorKey}.${index}.contact`] || (index === 0 && innited.customerContact  && !( customer && customer.data && customer.data.contact)) }">
                  <Multiselect
                    v-model="customers[index].data.contact"
                    :multiple="false"
                    :class="{
                      'scrollable': resolveOptions(customer).length > 7,
                    }"
                    :options="resolveOptions(customer)"
                    :disabled="shouldDisable(customer)"
                    :internal-search="true"
                    :allow-empty="false"
                    track-by="id"
                    label="full_name"
                    @input="updateContact(index)"
                  />
                </div>
                <div class="tw-w-full md:tw-w-2/12 tw-pt-2.5">
                  <FabricCheckbox
                    v-model="customers[index].is_primary"
                    :disabled="customers[index].is_primary"
                    slot-classes="!tw-pl-3 tw-text-black"
                    switch
                    @update="tryToSelectOnePrimary(index)"
                  >Primary</FabricCheckbox>
                </div>
              </div>
              <div class="col-md-10 pr-0">
                <p v-if="formError && formError[`${errorKey}.${index}.is_primary`]" class="text-danger">{{ formError[`${errorKey}.${index}.is_primary`] }}</p>
              </div>
            </div>
          </div>
          <div class="fl-left-right">
            <button
              v-if="canRemove(index)"
              type="button"
              class="btn button button-dashed-danger"
              @click="removeCustomer(index)">
              Remove
            </button>
            <span v-else/>
            <button
              type="button"
              :disabled="!canUpdate(index)"
              class="btn button button-dashed-positive"
              @click="toggleEditCustomer(index, false)">
              Update
            </button>
          </div>
        </div>
      </div>
      <div class="group-button mt-3">
        <button class="btn button-bd-dashed" @click="addCustomer">
          <div class="fl-al-center">
            <PlusIcon size="1.5x" class="custom-class float-left mr-2"></PlusIcon>
            <span class="item-text">Add Contact</span>
          </div>
        </button>
      </div>
      <p v-if="formError && formError[errorKey]" class="text-danger">{{ formError[errorKey] }}</p>
    </template>
  </div>
</template>
